// extracted by mini-css-extract-plugin
export default {"pagination":"pagination__1pSz3","item":"item__3jJw9","left":"left__21A0z","right":"right__2fBQH","active":"active__WEmoJ"};